module.exports = __webpack_public_path__ + "static/media/patternCapture.20629fc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/patternCapture.png
// module id = 193
// module chunks = 0